import { ModalProps } from '@vtex/admin-ui'
import { ConfirmationModal } from '../../../ConfirmationModal'
import { messages } from './messages'

type Props = {
  state: ModalProps['state']
  onConfirm: () => void
  onCancel: () => void
}

export function OptInConfirmationModal(props: Props) {
  const { state, onConfirm, onCancel } = props
  return (
    <ConfirmationModal
      messages={messages.confirmation}
      onCancel={onCancel}
      onConfirm={onConfirm}
      state={state}
    />
  )
}
